import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const Settings = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Settings</h1>
      
      <div className="grid gap-6">
        <Card className="p-4 md:p-6">
          <h2 className="text-lg font-semibold mb-4">Store Information</h2>
          <div className="space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="storeName">Store Name</Label>
              <Input id="storeName" placeholder="Enter store name" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="description">Store Description</Label>
              <Textarea id="description" placeholder="Enter store description" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="email">Contact Email</Label>
              <Input id="email" type="email" placeholder="Enter contact email" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="phone">Contact Phone</Label>
              <Input id="phone" type="tel" placeholder="Enter contact phone" />
            </div>
            
            <Button>Save Changes</Button>
          </div>
        </Card>

        <Card className="p-4 md:p-6">
          <h2 className="text-lg font-semibold mb-4">Payment Settings</h2>
          <div className="space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="bankName">Bank Name</Label>
              <Input id="bankName" placeholder="Enter bank name" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="accountNumber">Account Number</Label>
              <Input id="accountNumber" placeholder="Enter account number" />
            </div>
            
            <div className="grid gap-2">
              <Label htmlFor="routingNumber">Routing Number</Label>
              <Input id="routingNumber" placeholder="Enter routing number" />
            </div>
            
            <Button>Update Payment Info</Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Settings;